import React from 'react'
import styled from 'styled-components'

const H1 = styled.h1`
  @media (max-width: 767px) {
    font-size: 2rem;
  }
  color: #222;
  font-size: 3rem;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 0.75em;
  margin: 0;
  padding: 0;
  border: 0;
`

export default H1
